// SC-4235: the team selector defaulted to a seemingly random team on load
// because the selected team was plain in-memory React state, reset to '' on
// every page load. These helpers persist the last-selected team per-user in
// localStorage so a returning user lands back on the team they last worked
// in, instead of falling through to the (previously unordered) teams[0].
//
// Keyed by (userId, orgId), not userId alone: a single userId can back
// Profiles in multiple orgs (Team.profilesForSwitch / the app switcher), and
// Team ids are org-scoped, so a team persisted in org A is meaningless — and
// would otherwise get clobbered — in org B.
const KEY_SUFFIX = 'selectedTeam';

export function getSelectedTeamStorageKey(
  userId: string | undefined,
  orgId: string | undefined,
): string | null {
  return userId && orgId ? `${userId}:${orgId}:${KEY_SUFFIX}` : null;
}

export function readStoredSelectedTeam(
  userId: string | undefined,
  orgId: string | undefined,
): string {
  const key = getSelectedTeamStorageKey(userId, orgId);
  if (!key) {
    return '';
  }
  try {
    return localStorage.getItem(key) ?? '';
  } catch {
    // e.g. private browsing / storage disabled — fall back to no persistence
    return '';
  }
}

export function writeStoredSelectedTeam(
  userId: string | undefined,
  orgId: string | undefined,
  teamId: string,
): void {
  const key = getSelectedTeamStorageKey(userId, orgId);
  if (!key) {
    return;
  }
  try {
    localStorage.setItem(key, teamId);
  } catch (error) {
    // e.g. private browsing / quota exceeded — persistence is best-effort
    console.error('Error saving selected team to localStorage:', error);
  }
}
